import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components'

import { Container } from 'components/atoms/container'
// import { Container } from '@mantine/core'

export const StyledInfoContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const StyledIconHeading = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 12px;
  & > label {
    margin-left: 4px;
    color: ${theme.colors.gray400};
    font-weight: ${theme.sizes.fwBold};
  }
`

export const StyledContainer = styled(Container)`
  /* width: 100%; */
  padding: 0;
`
